import { createConnectedStore, withReduxDevtools } from 'undux';

const initialState = {
  mainMenuOffset: 0,
  mediaRegion: 'other',
  pageType: '',
  playlistInfo: {
    activeChip: null,
    activePlaylist: [],
    playlists: [],
    playlistIndex: null,
    trayIndex: 0
  },
  playlistIndex: 0,
  youtubeSelectedVideo: null
};

const hasReduxDevTools = typeof window !== 'undefined'
  && process.env.NODE_ENV === 'development'
  && window.__REDUX_DEVTOOLS_EXTENSION__;

const devtools = hasReduxDevTools ? withReduxDevtools : '';

export default createConnectedStore(initialState, devtools);
